import {
  FETCH_DOCUMENT_LIST_FOR_TASK_REQUEST,
  FETCH_DOCUMENT_LIST_FOR_TASK_SUCCESS,
  FETCH_DOCUMENT_LIST_FOR_TASK_FALUIRE,
} from './documentListForTaskTypes'

const initialState = {
  loading: false,
  documentListForTask: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENT_LIST_FOR_TASK_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DOCUMENT_LIST_FOR_TASK_SUCCESS : return {
      ...state,
      documentListForTask: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DOCUMENT_LIST_FOR_TASK_FALUIRE : return {
      ...state,
      loading: false,
      documentListForTask: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
